export default "__VITE_ASSET__D5r4XI6U__"